import { ShiftDigitalData, TealiumEventsData } from '@/types/writeup';
import Axios, { AxiosError } from 'axios';

const axios = Axios.create({
	baseURL: (window as Window).location.href,
});

export class AnalyticsService {
	public sdEventTracking(payload: {eventName: string; shiftDigitalData: Partial<ShiftDigitalData>}) {
		if (payload.eventName && typeof (window as Window).sendSDEvent !== 'undefined') {
			const eventData = payload.shiftDigitalData;

			delete eventData.clientId;
			delete eventData.retailerId;
			delete eventData.jsScriptUrl;
			(window as Window).sendSDEvent('dataLayer', {
				digRet: eventData,
				events: payload.eventName,
				sessionId: payload.shiftDigitalData.sessionId,
			});
			(window as Window).sendSDEvent('send');
		}
	}

	public gtmEventTracking(eventData: any) {
		if ((window as Window).sendGoogleTagManagerData !== undefined) {
			(window as Window).sendGoogleTagManagerData(eventData);
		}
	}

	public updateTealiumDataLayer(data: Partial<TealiumEventsData>, sendEvent = true) {
		if ((window as Window).updateTealiumDataLayer) {
			(window as Window).updateTealiumDataLayer(data, sendEvent);
		}
	}

	public serverDateTime(): Promise<string> {
		return axios.head('')
			.then(res => res.headers.date)
			.catch((error: AxiosError) => {
				if (error?.response?.status === 404) {
					return Promise.resolve(null);
				}
				throw error;
			});
	}
}
